import React from 'react';

import createIcon from './createIcon';

export default createIcon('0 0 16 16', <circle cx="7.99414" cy="8.18848" r="5.33" />);
